import React, { useState, useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { string, shape, arrayOf } from 'prop-types'

import Select from '@components/Select'
import useSelectOption from '@hooks/useSelectOption'

export default function DynamicSelect({
  field,
  errors,
  control,
  setValue,
  clearErrors,
  getValues,
  setFunnelStage,
}) {
  const [items, setItems] = useState([])

  const asyncItems = useSelectOption(field)
  useEffect(() => {
    if (asyncItems.length > 0) {
      setItems([...asyncItems])
    }
  }, [asyncItems])

  const handleChange =
    field.actions && field.actions.onChange
      ? field.actions.onChange(setValue, clearErrors, getValues, setFunnelStage)
      : ([selected]) => selected

  return (
    <div data-testid="dynamic-form-select">
      <Controller
        as={Select}
        control={control}
        name={field.name}
        label={field.label}
        errorMessage={errors && errors.message}
        onChange={handleChange}
        defaultValue=""
      >
        {items.map(elem => (
          <option key={elem.value} value={elem.value}>
            {elem.name}
          </option>
        ))}
      </Controller>
    </div>
  )
}

DynamicSelect.propTypes = {
  field: shape({
    label: string,
    name: string,
    items: shape({
      defaultElements: shape({
        elements: arrayOf(
          shape({
            value: string,
            name: string,
          })
        ),
      }),
    }),
  }).isRequired,
  control: shape({}).isRequired,
  errors: shape({}),
  setValue: shape({}),
  clearErrors: shape({}),
  getValues: shape({}),
  setFunnelStage: shape({}),
}

DynamicSelect.defaultProps = {
  errors: {},
  setValue: {},
  clearErrors: {},
  getValues: {},
  setFunnelStage: {},
}
